export const FILDS_ZENDEKS = {
	NAME: 360024434393,
	DOCUMENT: 360040365273,
	REASON: 1900007283944,
	PROBLEM: 1900007284124,
	ENROLL: 1900007284944,
};
